import BridgeSessionGate from "../../components/bridge-session-gate";
import Activator from "./activator";
import React from "react";
import ModalManager from "../../components/modals/ModalManager";
import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  height: 100%;
`;

export default function({
  match: {
    params
  }
}) {

  function getLocation() {
    const location = params.location;
    switch (params.locationType) {
      case "pageid":
        return { result_id: location }
      case "cfi":
      case "epubcfi":
        return { cfi: "/" + location }
      default:
        return undefined
    }
  }

  return (
    <BridgeSessionGate>
      <Container>
        <Activator isbn={params.isbn} location={getLocation()} />
        <ModalManager />
      </Container>
    </BridgeSessionGate>
  );
}
